import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const suppliesCollectionFilterFields = ["tags", "vendor"] as const;
export type SuppliesCollectionFilterField =
  (typeof suppliesCollectionFilterFields)[number];

export const getSuppliesCollectionFilterValues = unaryRpc({
  name: "getSuppliesCollectionFilterValues" as const,
  input: z.object({
    field: z.enum(suppliesCollectionFilterFields),
    filterSearch: z.string().nullish(),
  }),
  output: z.object({ values: z.array(z.string()) }),
});
